var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { isArr } from '@formily/shared';
import { batch } from '@formily/reactive';
import { spliceArrayState, exchangeArrayState } from '../shared';
import { Field } from './Field';
var ArrayField = (function (_super) {
    __extends(ArrayField, _super);
    function ArrayField(address, props, form, controlled) {
        var _this = _super.call(this, address, __assign(__assign({}, props), { value: isArr(props.value) ? props.value : [] }), form, controlled) || this;
        _this.displayName = 'ArrayField';
        _this.push = function () {
            var items = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                items[_i] = arguments[_i];
            }
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    if (!isArr(this.value))
                        return [2];
                    return [2, batch(function () {
                            var _a;
                            (_a = _this.value).push.apply(_a, __spread(items));
                            return _this.onInput(_this.value);
                        })];
                });
            });
        };
        _this.pop = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!isArr(this.value))
                    return [2];
                return [2, batch(function () {
                        var index = _this.value.length - 1;
                        _this.value.pop();
                        spliceArrayState(_this, {
                            startIndex: index,
                            deleteCount: 1,
                        });
                        return _this.onInput(_this.value);
                    })];
            });
        }); };
        _this.insert = function (index) {
            var items = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                items[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    if (!isArr(this.value))
                        return [2];
                    return [2, batch(function () {
                            var _a;
                            (_a = _this.value).splice.apply(_a, __spread([index, 0], items));
                            spliceArrayState(_this, {
                                startIndex: index,
                                insertCount: items.length,
                            });
                            return _this.onInput(_this.value);
                        })];
                });
            });
        };
        _this.remove = function (index) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!isArr(this.value))
                    return [2];
                return [2, batch(function () {
                        _this.value.splice(index, 1);
                        spliceArrayState(_this, {
                            startIndex: index,
                            deleteCount: 1,
                        });
                        return _this.onInput(_this.value);
                    })];
            });
        }); };
        _this.shift = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!isArr(this.value))
                    return [2];
                return [2, batch(function () {
                        _this.value.shift();
                        return _this.onInput(_this.value);
                    })];
            });
        }); };
        _this.unshift = function () {
            var items = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                items[_i] = arguments[_i];
            }
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    if (!isArr(this.value))
                        return [2];
                    return [2, batch(function () {
                            var _a;
                            (_a = _this.value).unshift.apply(_a, __spread(items));
                            spliceArrayState(_this, {
                                startIndex: 0,
                                insertCount: items.length,
                            });
                            return _this.onInput(_this.value);
                        })];
                });
            });
        };
        _this.move = function (fromIndex, toIndex) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!isArr(this.value))
                    return [2];
                if (fromIndex === toIndex)
                    return [2];
                return [2, batch(function () {
                        var fromItem = _this.value[fromIndex];
                        _this.value.splice(fromIndex, 1);
                        _this.value.splice(toIndex, 0, fromItem);
                        exchangeArrayState(_this, {
                            fromIndex: fromIndex,
                            toIndex: toIndex,
                        });
                        return _this.onInput(_this.value);
                    })];
            });
        }); };
        _this.moveUp = function (index) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!isArr(this.value))
                    return [2];
                return [2, this.move(index, index - 1 < 0 ? this.value.length - 1 : index - 1)];
            });
        }); };
        _this.moveDown = function (index) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!isArr(this.value))
                    return [2];
                return [2, this.move(index, index + 1 >= this.value.length ? 0 : index + 1)];
            });
        }); };
        return _this;
    }
    return ArrayField;
}(Field));
export { ArrayField };
